<template>
    <job-posting-page :posting="posting" :group="eventStore.event" is-sub-page/>
</template>

<script setup lang="ts">

import {useEventStore} from "../../../../store/event";

const {$api, $web} = useNuxtApp();
const route = useRoute();
const eventStore = useEventStore();
const {t} = useI18n();

const {data: posting} = await useApiFetch($api('events.job_postings.show', [eventStore.event.id, route.params.job]), {
	guest: true,
	params: {
		with_similar_jobs: true
	}
})

useMeta({
	title: eventStore.buildPageTitle(t('view.events.jobs.show.title', {event: eventStore.event.display_name, job: posting.title})),
	description: posting.short_description,
	canonical: $web('jobs.events.jobs.show', [eventStore.event._key, posting._key], true)
})

</script>

